import { ref } from 'vue';

export default {
  data() {
    return {
      isSyncingSelection: false,
    };
  },
  methods: {
    selectionChange(data, selection) {
      if (this.isSyncingSelection) return; // 在同步过程中，不处理选中状态变更
      const selectedIdsOnCurrentPage = data.map((item) => item.id);
      this.ids = this.ids
        .filter((id) => !selectedIdsOnCurrentPage.includes(id)) // 移除当前页面不再选中的ID
        .concat(selection.map((item) => item.id)); // 添加当前页面新选中的ID
      this.single = this.ids.length !== 1;
      this.multiple = !this.ids.length;
    },
    syncSelection(data) {
      this.$refs.multipleTable.clearSelection();
      data.forEach((row) => {
        if (this.ids.includes(row.id)) {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        }
      });
    },
  },
};
